export const USER_SET = 'USER_SET'
export const USER_UNSET = 'USER_UNSET'
export const USER_FETCH = 'USER_FETCH'
export const USER_CREATE = 'USER_CREATE'
export const USER_UPDATE = 'USER_UPDATE'
